import SVGIcon, { IconProps } from './Icon';

export const ChevronRightIcon = (props: IconProps) => (
  <SVGIcon {...props}>
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
  </SVGIcon>
);

export default ChevronRightIcon;
